import {
    KEY_ISSUE_LIST_PAGE_REQUEST,
    KEY_ISSUE_LIST_RESPONSE,
    KEY_ISSUE_LIST_SEARCH_REQUEST,
    KEY_ISSUE_APPLY_FILTER_CRITERIA,
    KEY_ISSUE_CANCEL_MODEL_UPDATE,
    KEY_ISSUE_ITEM_REQUEST,
    KEY_ISSUE_ITEM_RESPONSE,
    KEY_ISSUE_APPLY_MODEL_UPDATE,
    KEY_ISSUE_UPDATE_CONCEPTS,
    KEY_ISSUE_MAPPING_PREVIEW_REQUEST,
    KEY_ISSUE_MAPPING_DELETE_PREVIEW_REQUEST,
    KEY_ISSUE_REMOVE_MAPPING,
    KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS,
    KEY_ISSUE_REMOVE_OWNER_VIEWER,
    KEY_ISSUE_ITEM_SAVE_RESPONSE
} from "../actions/action-types"
import {
    keyIssueListPageRequest,
    keyIssueItemRequest,
    keyIssueItemResponse,
    keyIssueItemSaveResponse,
    keyIssueMappingPreviewRequest,
    keyIssueMappingDeletePreviewRequest,
    keyIssueMappingPreviewResponse,
    keyIssueMappingPreviewErrorResponse,
    keyIssueSearchAddOwnersViewersResponse,
    keyIssueUpdateModel
} from "../actions/key-issue-actions"
import { defaultSearchCriteria } from "../reducers/paging/dimension-paging-reducer"
import {
    dimensionListRequest,
    dimensionItemRequest,
    dimensionItemSaveRequest
} from "../actions/dimension-actions"
import { autocompleteOwnerViewerRequest } from "../actions/autocomplete-actions"
import {
    postDimensionPreviewMapping,
    deleteDimensionPreviewMapping
} from "../api/dimension-api"
import {
    requestListSearchEpic,
    requestListFilterEpic,
    requestTopItemFromListResponseEpic,
    syncIdToURLEpic,
    removeOwnerViewerEpic
} from "./default-epics/default-entity-epics"
import {
    updateMappingConceptEpic,
    removeMappingEpic,
    requestMappingPreviewEpic
} from "./default-epics/mapping-epics"
// import { idify } from "../reducers/paging/paging-reducer-utils"

export const requestKeyIssueSearchEpic = requestListSearchEpic(
    KEY_ISSUE_LIST_SEARCH_REQUEST,
    keyIssueListPageRequest,
    "keyIssues",
    "dimensions"
)

export const applyKeyIssueFilterCriteria = requestListFilterEpic(
    KEY_ISSUE_APPLY_FILTER_CRITERIA,
    keyIssueListPageRequest,
    "keyIssues",
    "dimensions"
)

export const requestKeyIssuePageEpic = action$ =>
    action$
        .ofType(KEY_ISSUE_LIST_PAGE_REQUEST)
        .map(({ type, ...pagingRequest }) =>
            dimensionListRequest(pagingRequest)
        )

export const requestKeyIssueItemEpic = action$ =>
    action$
        .ofType(KEY_ISSUE_ITEM_REQUEST)
        .map(({ id, isInvalidating }) =>
            dimensionItemRequest(id, isInvalidating, keyIssueItemResponse)
        )

export const requestKeyIssueCancelModelUpdateEpic = (action$, { getState }) =>
    action$
        .ofType(KEY_ISSUE_CANCEL_MODEL_UPDATE)
        .map(() => getState().presentation.keyIssues.activeId)
        .filter(id => id)
        .map(keyIssueItemRequest)

export const responseKeyIssueListEpic = requestTopItemFromListResponseEpic(
    KEY_ISSUE_LIST_RESPONSE,
    keyIssueItemRequest,
    "keyIssues",
    "dimensions",
    defaultSearchCriteria
)

export const syncKeyIssueIdToURLEpic = syncIdToURLEpic(
    "key-issues",
    KEY_ISSUE_ITEM_RESPONSE
)

export const keyIssueApplyModelUpdate = (action$, { getState }) =>
    action$.ofType(KEY_ISSUE_APPLY_MODEL_UPDATE).map(() => {
        let {
            updateModel,
            activeId,
            imageToUpload
        } = getState().presentation.keyIssues
        const placeholders_add = updateModel.get("placeholders_add")
        if (placeholders_add) {
            updateModel = updateModel.set(
                "placeholders_add",
                placeholders_add.map(({ image, attribution }) => ({
                    image,
                    attribution
                }))
            )
        }
        return dimensionItemSaveRequest(
            activeId,
            updateModel.toJS(),
            imageToUpload,
            keyIssueItemSaveResponse
        )
    })

export const responseKeyIssueItemSaveEpic = (action$, { getState }) =>
    action$
        .ofType(KEY_ISSUE_ITEM_SAVE_RESPONSE)
        .map(({ type: _, ...action }) => keyIssueItemResponse(action))

export const updateKeyIssueMappingConceptEpic = updateMappingConceptEpic(
    KEY_ISSUE_UPDATE_CONCEPTS,
    "keyIssues",
    keyIssueMappingPreviewRequest
)

export const removeKeyIssueMappingEpic = removeMappingEpic(
    KEY_ISSUE_REMOVE_MAPPING,
    "keyIssues",
    keyIssueMappingDeletePreviewRequest
)

export const requestKeyIssueMappingPreviewEpic = requestMappingPreviewEpic(
    [
        KEY_ISSUE_MAPPING_PREVIEW_REQUEST,
        KEY_ISSUE_MAPPING_DELETE_PREVIEW_REQUEST
    ],
    postDimensionPreviewMapping,
    deleteDimensionPreviewMapping,
    keyIssueMappingPreviewResponse,
    keyIssueMappingPreviewErrorResponse
)

export const keyIssueSearchAddOwnersViewersEpic = (action$, { getState }) =>
    action$
        .ofType(KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS)
        .map(({ searchTerm }) =>
            autocompleteOwnerViewerRequest(
                searchTerm,
                null,
                keyIssueSearchAddOwnersViewersResponse
            )
        )

export const keyIssueRemoveOwnerViewerEpic = removeOwnerViewerEpic(
    "keyIssues",
    KEY_ISSUE_REMOVE_OWNER_VIEWER,
    keyIssueUpdateModel
)
